export default "__VITE_ASSET__DiEIu6n0__"